var render = function () {
  var _vm$statistics2, _vm$statistics4, _vm$statistics6, _vm$statistics8, _vm$statistics10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_vm.viewAs !== 'employee' ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-card', {
    staticClass: "full-width cursor-pointer",
    on: {
      "click": function click($event) {
        var _vm$statistics;
        return _vm.showModal('Unassigned', (_vm$statistics = _vm.statistics) === null || _vm$statistics === void 0 ? void 0 : _vm$statistics.unassigned);
      }
    }
  }, [_c('b-card-title', [_vm._v("Unassigned")]), _c('b-card-text', {
    staticClass: "text-center font-weight-bold text-lg-center"
  }, [_c('h1', [_vm._v(_vm._s(((_vm$statistics2 = _vm.statistics) === null || _vm$statistics2 === void 0 ? void 0 : _vm$statistics2.unassigned) || 0))])])], 1)], 1) : _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-card', {
    staticClass: "full-width cursor-pointer",
    on: {
      "click": function click($event) {
        var _vm$statistics3;
        return _vm.showModal('Not Started', (_vm$statistics3 = _vm.statistics) === null || _vm$statistics3 === void 0 ? void 0 : _vm$statistics3.not_started);
      }
    }
  }, [_c('b-card-title', [_vm._v("Not Started")]), _c('b-card-text', {
    staticClass: "text-center font-weight-bold text-lg-center"
  }, [_c('h1', [_vm._v(_vm._s(((_vm$statistics4 = _vm.statistics) === null || _vm$statistics4 === void 0 ? void 0 : _vm$statistics4.not_started) || 0))])])], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-card', {
    staticClass: "full-width cursor-pointer",
    on: {
      "click": function click($event) {
        var _vm$statistics5;
        return _vm.showModal('Overdue', (_vm$statistics5 = _vm.statistics) === null || _vm$statistics5 === void 0 ? void 0 : _vm$statistics5.overdue);
      }
    }
  }, [_c('b-card-title', [_vm._v("Overdue")]), _c('b-card-text', {
    staticClass: "text-center font-weight-bold text-lg-center"
  }, [_c('h1', [_vm._v(_vm._s(((_vm$statistics6 = _vm.statistics) === null || _vm$statistics6 === void 0 ? void 0 : _vm$statistics6.overdue) || 0))])])], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-card', {
    staticClass: "full-width cursor-pointer",
    on: {
      "click": function click($event) {
        var _vm$statistics7;
        return _vm.showModal('In Progress', (_vm$statistics7 = _vm.statistics) === null || _vm$statistics7 === void 0 ? void 0 : _vm$statistics7.in_progress);
      }
    }
  }, [_c('b-card-title', [_vm._v("In Progress")]), _c('b-card-text', {
    staticClass: "text-center font-weight-bold text-lg-center"
  }, [_c('h1', [_vm._v(_vm._s(((_vm$statistics8 = _vm.statistics) === null || _vm$statistics8 === void 0 ? void 0 : _vm$statistics8.in_progress) || 0))])])], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-card', {
    staticClass: "full-width cursor-pointer",
    on: {
      "click": function click($event) {
        var _vm$statistics9;
        return _vm.showModal('Completed', (_vm$statistics9 = _vm.statistics) === null || _vm$statistics9 === void 0 ? void 0 : _vm$statistics9.completed);
      }
    }
  }, [_c('b-card-title', [_vm._v("Completed")]), _c('b-card-text', {
    staticClass: "text-center font-weight-bold text-lg-center"
  }, [_c('h1', [_vm._v(_vm._s(((_vm$statistics10 = _vm.statistics) === null || _vm$statistics10 === void 0 ? void 0 : _vm$statistics10.completed) || 0))])])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-view",
      "centered": "",
      "title": _vm.type,
      "hide-footer": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100 justify-content-center"
  }, [_c('h1', {
    staticClass: "font-large-1"
  }, [_vm._v(" " + _vm._s(_vm.value || 0) + " ")])])]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('DataTable', {
    attrs: {
      "endpoint": _vm.endpoint,
      "isSubtask": _vm.isSubtask
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }